<template>
  <div>
    <Head />
    <Navigation />
    <Wallpaper :src="src"/>
    <List :title="title" :items="items"/>
    <foot />
  </div>
</template>

<script>
import Head from '@/components/index/components/head'
import Wallpaper from '../components/wallpaper'
import List from '../components/list'
import Foot from '@/components/index/components/foot'
import Navigation from '@/components/index/components/nav'
export default {
  name: 'Solutions',
  components: {
    Head,
    Foot,
    Navigation,
    Wallpaper,
    List
  },
  data () {
    return {
      src: require('../components/wallpaper/5a7d0b8613cdf.jpg'),
      title: '解决方案',
      items : [
        {listName:'多物理耦合计算解决方案',url:'/solution/mob_1'},
        {listName:'实验室信息化解决方案',url:'/solution/mob_2'}
        ]
    }
  }
}
</script>

<style scoped>

</style>
